import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RoleDetailsService } from './core/services/role-details.service';
import { RoleSelectComponent } from './shared/components/reject-select/role-select.component';
import { LoggedUserDetailsService } from './core/services/logged-user-details.service';
import { RoleService } from './core/services/role.service';
import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { HttpClient } from '@angular/common/http';
import { EnvironmentLoaderService } from './core/services/environment-loader.service';
import { environment } from '../environments/environment.prod';
import { Location } from '@angular/common';

import { PrivacyConsentComponent } from './shared/components/privacy-consent/privacy-consent.component';
import { SessionExpiryDialogComponent } from './shared/components/session-expiry-dialog/session-expiry-dialog.component';
import { PersonaService } from './core/services/persona.service';
import { jwtDecode } from 'jwt-decode';
import { User } from './shared/models/user';
import { EnvService } from './env.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  // data = MockForm;
  roleDetails;
  menu = undefined;

  // telemtry configs
  BATCH_SIZE = 1;
  TELEMETRY_SERVICE_HOST = ''; // https://isgatewaytst.ad.infosys.com/telemetry //https://isosssvctst.ad.infosys.com
  TELEMETRY_SERVICE_ENDPOINT = '/v1/telemetry';
  UID = '';
  telemetryConfig = {
    pdata: {
      id: 'Intap-Operations-Persona',
      ver: '1.0',
      pid: 'intap',
    },
    uid: '',
    authtoken: localStorage.getItem('access-token'),
    env: 'HomePage',
    channel: 'web',
    batchsize: this.BATCH_SIZE,
    host: this.TELEMETRY_SERVICE_HOST,
    endpoint: this.TELEMETRY_SERVICE_ENDPOINT,
    apislug: '',
  };

  options = {
    context: {
      env: 'PersonaDashboard',
    },
    actor: {
      BANDCODE: '3',
      id: '',
      SBUCODE: 'IS',
      type: 'user',
      CURRENTCITY: 'MYSORE',
      COUNTRYCODE: 'IN',
    },
    runningEnv: 'ClientBrowser',
  };
  keyValueStore = {
    dbadmin: 'DBAD',
    dbassociate: 'DBAS',
    scheduleradmin: 'SCAD',
    scheduler: 'SCAS',
    offerdeo: 'OFDA',
    recruiter: 'RECRUITER',
    recruitmentmanager: 'RM',
    cnb: 'CnB',
    cnbadmin: 'CnBAdmin',
    cnbexecutive: 'CnBExecutive',
    recruitmenthead: 'RH',
    tpdhead: 'TPD',
    od: 'OD',
  };
  camsData = [];
  selectedRole = '';
  privacyflag: any;
  role: any;
  tncText: any;
  showTnc: boolean = false;
  empNo: string;
  tncVersionData: any;
  roleSelect: any;
  companyType: any;
  accessToken = localStorage.getItem('access-token');
  maintenanceMode: boolean = false;
  keyClockUrl: '';
  constructor(
    public dialog: MatDialog,
    private route: Router,
    private roleService: RoleDetailsService,
    private loggedUserDetails: LoggedUserDetailsService,
    private roleDetailService: RoleService,
    @Inject(TelemetryService) private _telemetryService: TelemetryService,
    private http: HttpClient,
    private envLoaderSerive: EnvironmentLoaderService,
    public userLocation: Location,
    private personaService: PersonaService,
    private envService: EnvService,
  ) {
    window.addEventListener('reportonly', (event: any) => {
      if (event.origin !== 'https://taptest.infosysapps.com/') {
        console.log(event);
        console.log('not from whitelisted source');
      } else {
        console.log(event);
      }
    });
  }

  openPrivacyDialog(): void {
    const dialogRef = this.dialog.open(PrivacyConsentComponent, {
      // width: '250px',
      data: { tncDoc: this.tncText },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.privacyflag = result;
      console.log(this.role);
      if (this.privacyflag) {
        const saveTnc = {
          acceptedVersion: this.tncVersionData.version,
          objectType: 'UD',
          docName: this.tncVersionData.docName,
          companyHiringTypeId: this.companyType,
          // "objectId":this.empNo
        };
        this.loggedUserDetails.saveUserTnc(saveTnc).subscribe((res) => {
          console.log(res);
          console.log(this.role);
          if (localStorage.getItem('roleCode') === '' || !localStorage.getItem('roleCode')) {
            this.getRouteFromRole(this.role);
            localStorage.setItem(
              'roleCode',
              this.roleSelect.role ? this.roleSelect.role : localStorage.getItem('roleCode'),
            );
            localStorage.setItem(
              'role',
              this.roleSelect.selectedRole ? this.roleSelect.selectedRole : localStorage.getItem('role'),
            );
            localStorage.setItem(
              'fresherCompHiringTypeId',
              this.roleSelect.selectedContext
                ? this.roleSelect.selectedContext
                : localStorage.getItem('fresherCompHiringTypeId'),
            );
            this.selectedRole = this.roleSelect.selectedRole;
            this.role = this.roleSelect.role;
          }
        });
      }
    });
  }

  openRejectDialog(camsRoles?): void {
    const dialogRef = this.dialog.open(RoleSelectComponent, {
      width: '500px',
      // height:'300px',
      data: camsRoles,
      panelClass: 'custom-modalbox',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.roleSelect = result;
      if (result.role) {
        // localStorage.setItem("roleCode", result.role ? result.role : localStorage.getItem('roleCode'))
        // localStorage.setItem("role", result.selectedRole ? result.selectedRole : localStorage.getItem("role"))
        // localStorage.setItem("fresherCompHiringTypeId", result.selectedContext ? result.selectedContext : localStorage.getItem("fresherCompHiringTypeId"))
        // this.selectedRole = result.selectedRole
        // this.role = result.role
        console.log('!!!', result);
        this.role = result.role;
        this.companyType = result.selectedContext;
        const contentType = 'user_privacyconsent';
        this.loggedUserDetails.gettncDate(this.companyType, contentType).subscribe((response) => {
          if (response) {
            this.tncVersionData = response;
            this.tncText = response['document'];

            const userTnc = {
              objectType: 'UD',
              docName: this.tncVersionData.docName,
              companyHiringTypeId: this.companyType,
            };

            this.loggedUserDetails.getUserTnc(userTnc).subscribe((response) => {
              if (response.showTnc == 'Y') {
                this.openPrivacyDialog();
              } else {
                localStorage.setItem('roleCode', result.role ? result.role : localStorage.getItem('roleCode'));
                localStorage.setItem('role', result.selectedRole ? result.selectedRole : localStorage.getItem('role'));
                localStorage.setItem(
                  'fresherCompHiringTypeId',
                  result.selectedContext ? result.selectedContext : localStorage.getItem('fresherCompHiringTypeId'),
                );
                this.selectedRole = result.selectedRole;
                this.role = result.role;
                this.getRouteFromRole(this.role);
              }
            });
          }
        });
        // this.getRouteFromRole(result.role)
        // api call to get companyHiringType
        // let body2 = {
        //   "appCode": "InTap",
        //   "isLoginUser": "yes",
        //   "roleCode": localStorage.getItem("role")
        // }
        // this.http.post<any[]>(environment.camsUrl + "Contexts", body2).subscribe(data => {
        //   console.log(data)
        //   console.log(localStorage.getItem("role"));

        //   for (let i = 0; i < data.length; i++) {
        //     console.log(data[i].appRoleName, data[i].contextName);

        //     if (data[i].appRoleName === localStorage.getItem("role") && data[i].contextName === "Company level") {
        //       console.log(data[i].contextName, data[i].contextValue, '&&&&&&&&&&&&&&');

        //       localStorage.setItem("fresherCompHiringTypeId", data[i].contextValue)
        //       break;
        //     }
        //   }

        // })

        // if (result.role) {
        //   this.roleDetails.forEach(roleData => {
        //     if (roleData.role === result.role) {
        //       if (result.role === 'DBAD' || result.role === 'DBAS') {

        //         this.roleService.updateRole(roleData.routes[0].subRole);

        //         this.menu = roleData.routes;

        //         this.route.navigate([roleData.routes[0].path])
        //       }
        //       else {
        //         this.roleService.updateRole(roleData.role);

        //         this.menu = undefined;
        //         window['role'] = roleData.role
        //         this.route.navigate([roleData.routes[0].path])
        //       }
        //     }
        //   });
        // }
      }
    });
  }
  ngOnInit() {

    console.log("@Pan number not saving in view profile@");

    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('userTabLocation');
    });

    localStorage.setItem('enableNewFlow', 'N'); // let it be n if api fails
    this.handleInactivity();

    window.addEventListener('token-expired', () => {
      this.showSessionExpiredPopup('Your session has expired. Please login again.');
    });

    if (this.route.url === '/') {
      // https://itgatewaytst.infosys.com/infosys/authorization/api/Roles
      // https://isgatewaytst.ad.infosys.com/cams/api/Roles/
      this.envLoaderSerive.getEnvData().then(
        (envjson) => {
          //to set retry delay for file upload
          window["retryDelay"] =  JSON.parse(envjson?.['retryDelay']);

          this.loggedUserDetails.setLoggedUserUrl(envjson['LoggedUserDetailsUrl']);
          this.keyClockUrl = envjson['KeyClock'];
          const user: any = jwtDecode(this.accessToken);
          const userDetails: User = {
            empNo: user.EmpNo,
            empEmail: user.email,
            empName: user.name,
            empLocation: null,
          };
          // this.loggedUserDetails.getUserDetails()
          // .subscribe(user => {
          console.log(user);
          this.empNo = user.EmpNo;
          this.UID = user.email.split('@')[0];
          console.log(this.UID);
          this.telemetryConfig['uid'] = user.email.split('@')[0];
          this.telemetryConfig['host'] = envjson['TelemetryServiceHost'];
          this.personaService.setLoggedUserDetails(userDetails);
          this.loggedUserDetails.setLoggedUserDetails(userDetails);
          this._telemetryService.provider = 'SUNBIRD';
          this._telemetryService.setProviderImplementation('SUNBIRD', this.telemetryConfig);
          this._telemetryService.start(this.telemetryConfig, 'contentId1', '1.0', this.options);
          // })

          const body = {
            appCode: 'InTap',
            isLoginUser: 'yes',
          };
          environment.camsUrl = envjson['CamsUrl'];
          environment.maintenanceMode = envjson['maintenanceMode'];
          this.http.post<any[]>(environment.camsUrl + 'Roles', body).subscribe((camsRole) => {
            //   let camsRoles = [
            //     {
            //         "roleName": "DB Admin",
            //         "roleDesc": "DB Anchor"
            //     },
            //     {
            //         "roleName": "DB Associate",
            //         "roleDesc": "DB Associate"
            //     },
            //     {
            //         "roleName": "Operations",
            //         "roleDesc": "Operations"
            //     },
            //     {
            //         "roleName": "Rec_lead",
            //         "roleDesc": "Rec_lead"
            //     },
            //     {
            //         "roleName": "Recruiter",
            //         "roleDesc": "Recruiter"
            //     },
            //     {
            //         "roleName": "Scheduler Admin",
            //         "roleDesc": "Scheduler Anchor"
            //     },
            //     {
            //         "roleName": "RecLeadAM",
            //         "roleDesc": "TA- Agency Manager"
            //     },
            //     {"roleName": "Offer DEO", "roleDesc": "Offer DEO"}
            // ]
            const camsRoles = camsRole;
            console.log(camsRoles);
            camsRoles.sort((a, b) => (b.roleDesc >= a.roleDesc ? -1 : 1));
            // console.log("sorted",camsRoles)
            this.camsData = camsRoles;
            // this.roleDetailService.getMaintenanceMode().subscribe(async (res: any) => {
            // console.log(res)
            // this.maintenanceMode = res.maintenanceMode;
            this.maintenanceMode = JSON.parse(environment.maintenanceMode);
            if (this.maintenanceMode) {
              this.route.navigate(['/maintenance']);
              return false;
            } else {
              if (window.location.pathname === '/maintenance') {
                this.route.navigate(['/']);
              }
              if (!this.camsData || this.camsData.length === 0) {
                this.route.navigate(['/unauth']);
                return;
              }
              // else if (this.camsData.length === 1) {
              //   localStorage.setItem("role", this.camsData[0].roleName)
              //   localStorage.setItem('roleCode', this.keyValueStore[this.camsData[0].roleName.toLowerCase().trim().split(" ").join("")])
              // }
              //this.fileService.downloadJsonFile('role.json');
              this.roleDetailService.getRoleDetails().subscribe((data) => {
                this.roleDetails = data;
                console.log(this.roleDetails);
                console.log(JSON.stringify(this.roleDetails));
                this.roleDetailService.setRole(this.roleDetails);
                if (localStorage.getItem('roleCode') === '' || !localStorage.getItem('roleCode')) {
                  this.openRejectDialog(this.camsData);
                } else {
                  // if(this.showTnc){
                  //   this.openPrivacyDialog();
                  // }
                  // else{
                  // this.getRouteFromRole(localStorage.getItem('roleCode'))
                  // }
                  console.log('Inside else app');
                  const contentType = 'user_privacyconsent';
                  const CompanyHiringType = localStorage.getItem('fresherCompHiringTypeId');
                  this.companyType = localStorage.getItem('fresherCompHiringTypeId');
                  this.loggedUserDetails.gettncDate(CompanyHiringType, contentType).subscribe((response) => {
                    if (response) {
                      this.tncVersionData = response;
                      this.tncText = response['document'];

                      const userTnc = {
                        objectType: 'UD',
                        docName: this.tncVersionData.docName,
                        companyHiringTypeId: CompanyHiringType,
                      };

                      this.loggedUserDetails.getUserTnc(userTnc).subscribe((res) => {
                        if (res.showTnc == 'Y') {
                          this.openPrivacyDialog();
                        } else {
                          this.getRouteFromRole(localStorage.getItem('roleCode'));
                        }
                      });
                      this.setHMFlag();
                      // this.getRouteFromRole(localStorage.getItem('roleCode'))
                    }
                  });
                }
              });
              // api call to get companyHiringType
              // let body2 = {
              //   "appCode": "InTap",
              //   "isLoginUser": "yes",
              //   "roleCode": localStorage.getItem("role")
              // }
              // this.http.post<any[]>(environment.camsUrl + "Contexts", body2).subscribe(data => {
              //   console.log(data)
              //   for (let i = 0; i < data.length; i++) {
              //     if (data[i].appRoleName === localStorage.getItem("role") && data[i].contextName === "Company level") {
              //       localStorage.setItem("fresherCompHiringTypeId", data[i].contextValue)
              //       break;
              //     }
              //   }
              // })
              // localStorage.setItem("fresherCompHiringTypeId", JSON.stringify(1))
            }
            // })
          });

          // this.roleService.getRoles().subscribe(data => {
          //   this.roleDetails = data
          // });
        },
        //this.roleDetailService.getRoleDetails().then(data => console.log("json data---"+data));
      );
    }
    // this.checkIdleTime();
    // localStorage.setItem("enableNewFlow","N");
  }

  getRouteFromRole(role) {
    console.log(this.roleDetails);
    if (role) {
      this.roleDetails.forEach((roleData) => {
        if (roleData.role === role) {
          if (role === 'DBAD' || role === 'DBAS') {
            if (localStorage.getItem('fresherCompHiringTypeId') == '2') {
              this.roleService.updateRole(roleData.routes[1].subRole);
              this.menu = roleData.routes.filter((role) => {
                if (localStorage.getItem('roleCode') === 'DBAD') {
                  return (
                    role.menu == 'Duplication Check' || role.menu == 'Create Candidate' || role.menu == 'Bulk Creation'
                  );
                } else {
                  return role.menu == 'Duplication Check' || role.menu == 'Create Candidate';
                }
              });
              if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                this.route.navigate([roleData.routes[0].path]);
              }
            }
            // Condition can be removed when Bulk Creation is required for all CHT.
            else if (
              localStorage.getItem('roleCode') !== 'DBAS' &&
              (localStorage.getItem('fresherCompHiringTypeId') == '1' ||
                localStorage.getItem('fresherCompHiringTypeId') == '6')
            ) {
              this.roleService.updateRole(roleData.routes[0].subRole);
              this.menu = roleData.routes.filter((role) => {
                return role.menu;
              });
              if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                this.route.navigate([roleData.routes[0].path]);
              }
            } else if (
              (localStorage.getItem('roleCode') == 'DBAS' && localStorage.getItem('fresherCompHiringTypeId') == '4') ||
              localStorage.getItem('fresherCompHiringTypeId') == '9'
            ) {
              this.roleService.updateRole(roleData.routes[0].subRole);
              this.menu = roleData.routes.filter((role) => {
                return role.menu;
              });
              if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                this.route.navigate([roleData.routes[0].path]);
              }
            } else {
              this.roleService.updateRole(roleData.routes[0].subRole);
              this.menu = roleData.routes.filter((role) => {
                return role.menu !== 'Bulk Creation'; // return role.menu;
              });
              if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                this.route.navigate([roleData.routes[0].path]);
              }
            }
            // let dbRoles = roleData.hiringIdPaths.find(rotes => { return rotes.hiringId == localStorage.getItem("fresherCompHiringTypeId") })
            // this.roleService.updateRole(dbRoles.routes[0].subRole);
            // this.menu = dbRoles.routes;
            // if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != "false") {
            //   this.route.navigate([dbRoles.routes[0].path])
            // }
          } else if (
            localStorage.getItem('roleCode') === 'OFDA' &&
            localStorage.getItem('fresherCompHiringTypeId') == '2'
          ) {
            this.roleService.updateRole(roleData.role);
            this.menu = undefined;
            window['role'] = roleData.role;
            this.route.navigate(['/offermicro/offer/bulkoffer']);
          } else if (
            localStorage.getItem('roleCode') === 'CnB' &&
            (localStorage.getItem('fresherCompHiringTypeId') == '4' ||
              localStorage.getItem('fresherCompHiringTypeId') == '9')
          ) {
            this.roleService.updateRole(roleData.role);
            this.menu = undefined;
            window['role'] = roleData.role;
            this.route.navigate(['/offermicro/approval/bpmcnbdashboard']);
          } else if (
            localStorage.getItem('roleCode') === 'Offer_Admin' &&
            localStorage.getItem('fresherCompHiringTypeId') == '1'
          ) {
            this.roleService.updateRole(roleData.role);
            this.menu = undefined;
            window['role'] = roleData.role;
            this.route.navigate(['/offermicro/approval/adminOffer']);
          } else if (
            (localStorage.getItem('roleCode') === 'CnBExecutive' &&
              localStorage.getItem('fresherCompHiringTypeId') == '11') ||
            (localStorage.getItem('roleCode') === 'CnB' && localStorage.getItem('fresherCompHiringTypeId') == '11')
          ) {
            this.roleService.updateRole(roleData.role);
            this.menu = undefined;
            window['role'] = roleData.role;
            this.route.navigate(['/offermicro/cnbExecutive/cnbeleven']);
          } else if (role == 'SCAD') {
            const scadRoles = roleData.hiringIdPaths.find((rotes) => {
              return rotes.hiringId == localStorage.getItem('fresherCompHiringTypeId');
            });
            this.roleService.updateRole(scadRoles.routes[0].subRole);
            this.menu = scadRoles.routes;
            this.roleDetailService.setSCADRoutes(scadRoles.routes);

            if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
              this.route.navigate([scadRoles.routes[0].path]);
            }
          } else {
            this.roleService.updateRole(roleData.role);

            this.menu = undefined;
            window['role'] = roleData.role;
            if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
              this.route.navigate([roleData.routes[0].path]);
            }
          }
        }
      });
    }
  }

  handleInactivity() {
    const storedTimeout = localStorage.getItem('sessionTime');
    const IDLE_TIMEOUT = storedTimeout ? parseInt(storedTimeout, 10) : 20 * 60 * 1000;
    const ACTIVITY_KEY = 'last-activity-timestamp';

    // Update timestamp on any user activity (shared across all tabs)
    let idleTimer = null;

    const startIdleTimer = () => {
      if (idleTimer) {
        clearTimeout(idleTimer);
      }
      idleTimer = setTimeout(() => {
        const last = parseInt(localStorage.getItem(ACTIVITY_KEY) || '0', 10);
        if (Date.now() - last >= IDLE_TIMEOUT) {
          console.log('[Inactivity] IDLE — showing popup, timer cleared');
          this.showSessionExpiredPopup('Your session has expired due to inactivity. Please login again.');
        }
      }, IDLE_TIMEOUT);
    };

    const updateActivity = () => {
      localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
      console.log('[Inactivity] User active — timestamp updated');
      startIdleTimer(); // restart timer from NOW
    };
    document.addEventListener('mousedown', updateActivity);
    document.addEventListener('keydown', updateActivity);
    document.addEventListener('scroll', updateActivity, true);
    document.addEventListener('touchstart', updateActivity);
    updateActivity();

    // Show popup if idle too long — runs when user comes back to this tab
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        const last = parseInt(localStorage.getItem(ACTIVITY_KEY) || '0', 10);
        const elapsed = Math.round((Date.now() - last) / 1000);
        console.log('[Inactivity] Tab visible again — last activity ' + elapsed + 's ago');
        if (Date.now() - last >= IDLE_TIMEOUT) {
          console.log('[Inactivity] IDLE — showing popup');
          this.showSessionExpiredPopup('Your session has expired due to inactivity. Please login again.');
        } else {
          console.log('[Inactivity] NOT idle — another tab was active');
        }
      }
    });

    // If another tab logs out, show popup on this tab too
    window.addEventListener('storage', (event) => {
      if (event.key === 'access-token' && !event.newValue) {
        console.log('[Inactivity] Another tab logged out');
        this.showSessionExpiredPopup('Your session has expired. Please login again.');
      }
    });
  }

  setHMFlag() {
    // call api to get the HM flag and set in local storage
    this.loggedUserDetails.getHMFlag().subscribe((data) => {
      if (data && data[0]) {
        localStorage.setItem('enableNewFlow', data[0].configKey);
      } else {
        localStorage.setItem('enableNewFlow', 'N');
      }
    });
  }
  // checkIdleTime() {
  //   //60000 = 2 minutes ==20 mins ==1200000
  //   let a = this;
  //   this.setIdleTimeout(1200000, function () {

  //     if (localStorage.getItem('idleTime') == 'TRUE') {
  //       console.log('oops! idle time!');
  //       if (localStorage.getItem('loggedInUser')) {
  //         console.log('Session logout!! Please loggedin again.');
  //         localStorage.clear();
  //         a.logout();
  //         // a.logout(baseUrl + '/careersite/joblist?type=ALL&countrycode=IN&companyhiringtype=IL');

  //       }

  //     }

  //   }, function () {
  //     console.log('Welcome Back!');
  //     localStorage.setItem('idleTime', 'FALSE');
  //   });

  // }

  // setIdleTimeout(millis, onIdle, onUnidle) {
  //   var timeout = 0;
  //   startTimer();

  //   function startTimer() {
  //     localStorage.setItem('idleTime', 'TRUE');
  //     let timeout = setTimeout(onExpires, millis);
  //     document.addEventListener("mousemove", onActivity);
  //     document.addEventListener("keypress", onActivity);
  //   }

  //   function onExpires() {
  //     timeout = 0;
  //     onIdle();
  //   }

  //   function onActivity() {

  //     if (timeout) clearTimeout(timeout);
  //     else onUnidle();
  //     //since the mouse is moving, we turn off our event hooks for 1 second
  //     document.removeEventListener("mousemove", onActivity);
  //     document.removeEventListener("keypress", onActivity);
  //     setTimeout(startTimer, 1000);
  //   }

  // }

  private sessionExpiredDialogOpen = false;

  showSessionExpiredPopup(message?: string): void {
    if (this.sessionExpiredDialogOpen) {
      return;
    }
    this.sessionExpiredDialogOpen = true;

    // Disable ALL cdk-overlay-containers (host + microfrontend) so nothing is clickable
    document.querySelectorAll('.cdk-overlay-container').forEach((el: HTMLElement) => {
      el.style.display = 'none';
    });

    // Hide all NgbModal dialogs, backdrops, Bootstrap modals, and pdf-viewer
    document
      .querySelectorAll(
        'ngb-modal-window, ngb-modal-backdrop, .modal, .modal-backdrop, .modal-dialogue, [role="dialog"], pdf-viewer',
      )
      .forEach((el: HTMLElement) => {
        el.style.display = 'none';
      });

    this.dialog.closeAll();

    const dialogRef = this.dialog.open(SessionExpiryDialogComponent, {
      width: '420px',
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'session-expiry-backdrop',
      panelClass: 'session-expiry-modalbox',
      data: {
        message: message || 'Your session has expired. Please login again.',
      },
    });

    // Re-enable only the overlay container that holds the session expiry dialog
    setTimeout(() => {
      const panel = document.querySelector('.session-expiry-modalbox');
      const container = panel?.closest('.cdk-overlay-container') as HTMLElement;
      if (container) {
        container.style.display = '';
        container.style.zIndex = '100000';
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.logout();
    });
  }

  logout() {
    const url = encodeURI(location.origin);
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('roleCode');
    localStorage.removeItem('role');
    localStorage.removeItem('userTabLocation');
    localStorage.removeItem('companyHiringType');
    localStorage.removeItem('navFlag');
    localStorage.removeItem('reqSid');
    window.location.href =
      this.keyClockUrl +
      '/realms/infosys/protocol/openid-connect/logout?post_logout_redirect_uri=' +
      url +
      '&id_token_hint=' +
      localStorage.getItem('idToken');

    // let initOptions = {
    //   url: 'https://identitypoc.infosysapps.com/auth', realm: 'infosys', clientId: 'infyclient'
    // }
    // let keycloak = Keycloak(initOptions);
    // keycloak.logout({redirectUri: "/"});
  }
}
